import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../../services/auth.service';
import { FlagService } from '../../../../shared/services/flag.service';
import { FlagType } from '../../../../shared/utils/enums';
import { EstablishmentService } from '../../../../services/establishment.service';
import { AssignUserToAgency } from '../../../../models/AssignUserToAgency';

@Component({
  selector: 'app-add-agency',
  templateUrl: './add-agency.component.html',
  styleUrl: './add-agency.component.scss'
})
export class AddAgencyComponent {

  form: FormGroup;
  loading = false;
  users: any[] = [];
  
  constructor(
    public dialogRef: MatDialogRef<AddAgencyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private agencyService: EstablishmentService,
    private fb: FormBuilder,
    private auth: AuthService,
    private flag: FlagService,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      id: [null],
      name: ['', Validators.required],
      siret: [
        '',
        [
          Validators.required,
          Validators.minLength(14),
          Validators.maxLength(14),
          Validators.pattern('^[0-9]*$'),
        ],
      ],
      address: ['', Validators.required],
      agencyResponsable: ['', Validators.required], 
      email: ['', [Validators.required, Validators.email]],
    });
    if (this.data) {
      console.log("Original data: ", this.data);
      const transformedData = {
        id: this.data.id,
        name: this.data.agencyName,
        address: this.data.address,
        email: this.data.mail,
        phone: this.data.phone,
        siret: this.data.siret,
        agencyResponsable: this.data.agencyResponsable, 
      };
      console.log("Transformed data: ", transformedData);
      this.form.patchValue(transformedData);
    }

    this.fetchUsers(); // Fetch the list of users
  }

  fetchUsers() {
    this.agencyService.getAgenciesUsers().subscribe({
      next: (users) => {
        this.users = users;
        if (this.data && this.data.agencyResponsable) {
          const currentUser = this.users.find(user => user.firstName === this.data.agencyResponsable);
          if (currentUser) {
            this.form.get('agencyResponsable')?.setValue(currentUser.id);
          }
        }
      },
      error: (err) => {
        console.error('Failed to fetch users', err);
      },
    });
  }

  isFieldInvalid(field: string, errorType: string): boolean | undefined {
    const control = this.form.get(field);
    return control?.hasError(errorType) && control?.touched;
  }

  get siretFormField() {
    return this.form.get('siret');
  }

  addContact() {
    this.loading = true;
    const body = this.form.value;

    if (!this.data) {
      console.log("Adding new agency");
      this.agencyService.addAgency(body).subscribe({
        next: (newAgency) => {
          console.log("New agency added:", newAgency);

          // Call assignDirigeanttoAgencyByAgencyId after adding the agency
          const assignPayload: AssignUserToAgency = {
              dirigeant_principal: body.agencyResponsable,
              name: body.name,
              address: body.address,
              email: body.email,
              phone: body.phone,
              siret: body.siret,
          };
          console.log("Assign payload:", assignPayload);
          this.agencyService
            .assignDirigeanttoAgencyByAgencyId(assignPayload, newAgency.id)
            .subscribe({
              next: () => {
                this.loading = false;
                this.dialogRef.close(true);
                this.flag.displayFlag(`Agence ajoutée avec succès et dirigeant assigné !`, FlagType.success);
              },
              error: (err) => {
                this.loading = false;
                console.error("Failed to assign dirigeant to agency:", err);
              },
            });
        },
        error: (err) => {
          this.loading = false;
          console.error("Failed to add agency:", err);
        },
      });
    } else {
      console.log("Updating agency with id:", this.data.id);

      // Directly call assignDirigeanttoAgencyByAgencyId
      const assignPayload: AssignUserToAgency = {
        dirigeant_principal: body.agencyResponsable,
          name: body.name,
          address: body.address,
          email: body.email,
          phone: body.phone,
          siret: body.siret,
      };
      console.log("Assign payload:", assignPayload);
      this.agencyService
        .assignDirigeanttoAgencyByAgencyId(assignPayload, this.data.id)
        .subscribe({
          next: () => {
            this.loading = false;
            this.dialogRef.close(true);
            this.flag.displayFlag(`Agence modifiée avec succès et dirigeant assigné !`, FlagType.success);
          },
          error: (err) => {
            this.loading = false;
            console.error("Failed to assign dirigeant to agency:", err);
          },
        });
    }
  }

}
